$( document ).ready(function() {
    getData(); 
    function getData(link='') {  
        newLink = link;
        console.log(newLink);
        if(newLink != '') {
            url = 'https://lagoapparel-development.nodejs.p80w.com/purchase-orders-by-customer?customer-id=5361054285983'+newLink;
        }
        else {
            url = 'https://lagoapparel-development.nodejs.p80w.com/purchase-orders-by-customer?customer-id=5361054285983';
        }
        console.log(url);
        $.ajax({

            url : url,
            // url : 'https://lagoapparel-development.nodejs.p80w.com/purchase-orders-by-customer?customer-id=5361054285983&next=eyJsYXN0X2lkIjo4NjU2MzE2MzM1NjcsImxhc3RfdmFsdWUiOiI4NjU2MzE2MzM1NjcifQ==',
            type : "GET",
            headers:{ 'access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJlbWFpbCI6InRlc3RpbmdAcDgwdy5jb20iLCJpYXQiOjE2MjM0MDg3Mzd9.WyJiY78qgbXjKPkgA2vYUawdurH6PJIRYMqDuFG4uzY' },
            success : function(response) {
                if(response) {
                    var customerName;
                    var orderName;
                    var salesRep = "TestSalesRep";
                    var requiredDate;
                    var status;
                    
                    nextCursor =response.body.next_cursor;
                    previousCursor = response.body.previous_cursor;
                    if(previousCursor == null) {
                        document.getElementById("previousURL").disabled = true;
                    } 
                    else {
                        document.getElementById("previousURL").disabled = false;
                    }
                    if(nextCursor == null) {
                        document.getElementById("nextURL").disabled = true;
                    } 
                    else {
                        document.getElementById("nextURL").disabled = false;
                    }
                    // console.log('nextcursor =',nextCursor);
                    purchaseOrders = response.body.purchase_orders;
                    // console.log('previouscursor =',previousCursor);
                    purchaseOrdersLength = response.body.purchase_orders.length;
                    for(var i=0;i<5;i++) {
                        customerName =  purchaseOrders[i].customer.name;
                        orderName = purchaseOrders[i].name;
                        requiredDate = getDate(purchaseOrders[i]);
                        console.log(customerName,orderName);
                        garmentDetails = purchaseOrders[i].line_items; 
                        
                        let productName = "";
                        let quantity =""; 
                        let setQuantity ="";
                        let count = 0;        
                        $.each(garmentDetails, function( key, value ) { // looping each line items
                            customerName = count == 0 ? customerName : "";
                            orderName = count == 0 ? orderName : "";
                            requiredDate = count == 0 ? requiredDate : "";                      
                            if(value.status == 'pendingAdminApproval') {
                                status = '<span class="Polaris-Tag pending">'+
                                '<span title="Wholesale" class="Polaris-Tag__TagText">Waiting for AdminApproval</span></span></td>';
                            }
                            else {
                                status = " ";
                            }
                            sku = getSku(value.properties);
                            productName = value.product_name;                        
                            k=0;
                            htmlText = "";
                            htmlContent='';
                        
                            $.each(value.items,function(keyItem,valueItem) {
                                //  k++;
                                newLine = "<br>";
                                // console.log(valueItem.quantity +': item quantity for loop'+k);
                                quantity = valueItem.quantity;
                                setQuantity = 'Qty:'+quantity;
                                setOtherProperty ="";
                                $.each(valueItem.options,function(keyOption,valueOption) {
                                    setOtherProperty += ',Color:'+valueOption.value;
                                });
                                replaceText = setOtherProperty.replace('Color','Size');
                                orderedText = reOrder(replaceText);
                                htmlText += setQuantity+orderedText;
                                htmlText  = htmlText+newLine;
                            });
                            htmlText = htmlText.slice(0,-4);
                            htmlContent+='<tr class="Polaris-DataTable__TableRow">'+
                                            '<th class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--firstColumn" scope="row">'+ customerName+'</th>'+
                                            '<td class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop">'+  orderName +'</td>'+     
                                            '<td class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop">'+
                                            '<span class="Polaris-TextStyle--variationStrong">'+productName+'</span>'+'<br>'+htmlText+'</br>'+
                                            'Assigned Artwork:'+
                                            '<br>'+sku+'<br/>'+
                                            // 'Name: <span class="Polaris-TextStyle--variationPositive">Ice Hockey</span></td>'+
                                            '<td class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop">'+  salesRep +'</td>'+
                                            '<td class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop">'+  requiredDate +'</td>'+
                                            '<td class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop">'+
                                            status+
                                            '<td class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"</td></tr>';  
                                            // alert(htmlContent);
                            count = parseInt(count)+1;
                            $("#tableId tbody").append(htmlContent);
                        });
                        // $("#tableId tbody").html(htmlContent);
                    }    
                }
            },
            error :function(error) {
                console.log(error);
            }    
        });
    
        function getDate(order) {  //function for getting date of order.
            var productItem;
            lineItems = order.line_items;
            Object.keys(lineItems).forEach(key => {
                productItem = lineItems[key];
                if ('required_by' in productItem) {
                    if(productItem['required_by'] !== undefined) {
                        date = productItem['required_by'];
                    }
                    else {
                        date = "not specified";
                    }
                } 
            }); 
            return date;
        }

        function reOrder(property) {  // function used to ordering it [ Qty:1,Color:Red,Size:S ] 
            array = property.split(",");
            array.shift();
            array.reverse();
            text =','+array.toString();
            return text;
        }

        function getSku(properties) {  //function used to obtaining the Sku and Name .Here the name id hard coded .
            // console.log(properties);
            let skuValue = '';
            let filteredResult = properties.filter(prop => prop.name.startsWith("Artwork-"));
            //  console.log(filteredResult);
            Object.values(filteredResult).forEach(function(value){
                Object.assign(value,{Name: "Ice Hockey"}); 
            });
            //  console.log(filteredResult);
            skuValue = "";
            filteredResult.forEach(function(assignedArray){
                // console.log(assignedArray['name'].split('-').pop());
                skuValue += 'SKU:' + assignedArray['name'].split('-').pop()+'<br>Name:'+assignedArray['Name']+'<br>';
                // console.log(skuValue);
            });
            return skuValue;
            // if(test.length == 0){
            //     console.log(skuValue);
            // }
            // else
            // {
            //     console.log(skuValue);
            //     skuArray = test[0];
            //     return(skuArray.name.substring(skuArray.name.indexOf('-') + 1));

            // }   
        }  

        document.getElementById("nextURL").onclick = function ()  // function for next pagination
        {   
            $("#tableId tbody").html('');
            if(nextCursor != "")
            { 
                newUrl = '&next='+nextCursor;
                // console.log(newUrl);
                getData(newUrl);
            }   
        };

        document.getElementById("previousURL").onclick = function ()  // function for previous pagination.
        {   
            $("#tableId tbody").html('');
            if(previousCursor != null) {
                newUrl = '&previous='+previousCursor;
                //console.log(newUrl);
                getData(newUrl);
            }   
        };
        
    }//end of getdata()   
}); //end of ready function

